module.exports = __webpack_public_path__ + "img/product07.3173f649.jpg";